import React, { useState } from 'react';
import { Dropdown, Button, Modal } from 'react-bootstrap';
import axios from "axios";
//import download from 'downloadjs';

const Invia_mail_iniziale = (props) => {

    const [value, setValue] = useState();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    function invia_mail_di_inizio_stage() {
        console.log('invia_mail_di_inizio_stage');

    }


    const handleSubmit1 = (e) => {
        alert('scrivi qualcosa')

    }

    function invia_mail_di_inizio_stage() {
        console.log('invia_mail_di_inizio_stage');
        let nuovo_progetto = {
            id: props.progetto._id,
            id_alunno: props.progetto.id_alunno,
            id_ditta: props.progetto.id_ditta,
            data_inizio: props.progetto.data_inizio,
            data_fine: props.progetto.data_fine
        }

        nuovo_progetto.tutor = props.tutor
        console.log(nuovo_progetto);
        axios.post('/progetti/invia_mail_inizio_stage', nuovo_progetto)

        axios.patch('/progetti/stage_confermato_dalla_ditta/' + props.progetto._id + '/' + '-1')
            .then((res) => {
                console.log(res.data)
                //                SET_variab_aggiorna(JSON.stringify(res.data))
            }).catch((error) => {
                console.log(error)
            });
        handleClose()
        props.SET_variab_aggiorna(current => !current)
    }





    return (
        <div>
            <Dropdown.Item onClick={() => setShow(true) }>invia mail per inizio stage</Dropdown.Item>
         
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>Invia una mail alla Ditta</Modal.Title>
                </Modal.Header>
                <Modal.Body> <p>Mail inviata all'azienda per formalizzare l'inizio del percorso PCTO</p>
                             <p>Mail della ditta: {props.progetto.id_ditta.email} </p>
                </Modal.Body>
                <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Annulla
            </Button>
          
        
            <Button variant="primary" onClick={() => invia_mail_di_inizio_stage()}>
                Invio 
            </Button>
        </Modal.Footer>
        </Modal>
        </div>
    )
}
export default Invia_mail_iniziale;